module.exports = __webpack_public_path__ + "media/svg/poposta-b99cb940.svg";